export function getAuthConfig() {
  const domain = import.meta.env.VITE_AUTH_DOMAIN?.trim()
  const clientId = import.meta.env.VITE_AUTH_CLIENT_ID?.trim()
  const audience = import.meta.env.VITE_AUTH_API_ORIGIN?.trim()
  const appOrigin = import.meta.env.VITE_AUTH_APP_ORIGIN?.trim()
  const organization = import.meta.env.VITE_AUTH_ORGANIZATION?.trim()
  const connection = import.meta.env.VITE_AUTH_CONNECTION?.trim()

  return {
    domain,
    clientId,
    audience,
    appOrigin,
    organization,
    connection,
  }
}
